import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { ImageCapture } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

export const fetchImageCaptures = async (): Promise<
  CollectionResponse<ImageCapture>
> =>
  axiosInstance.get(`/admin/image-captures`).then((response) => response.data);

export const createImageCapture = async (data: ImageCapture): Promise<null> => {
  return axiosInstance
    .post(`/admin/image-captures`, data)
    .then((response) => response.data);
};

export const updateImageCaptureById = async (
  id: string,
  data: ImageCapture,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/image-captures/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteImageCaptureById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/image-captures/${id}`)
    .then((response) => response.data);

export const fetchImageCaptureById = async (
  id: string,
): Promise<ImageCapture> =>
  axiosInstance
    .get(`/admin/image-captures/${id}`)
    .then((response) => response.data);
